export default function roomMeetingNoteEventListener(room) {
  return store => {
    room.addEventListeners({
        room_meetingNote_init: e => {
            store.commit('meetingNote/MEETING_NOTE_INIT', e.data)
        },
        start_meeting_note: function (e) {
            store.commit('meetingNote/ADD_MEETING_NOTE', e.data)
        },
        stop_meeting_note: function (e) {
            store.commit('meetingNote/STOP_MEETING_NOTE', e.data)
        },
        delete_meeting_note: function (e) {
            store.commit('meetingNote/DELETE_MEETING_NOTE', e.data)
        },
        start_meeting_note_summary: function (e) {
            store.commit('meetingNote/UPDATE_MEETING_NOTE_SUMMARY_STATE', e.data)
        },
        completed_meeting_note_summary: function (e) {
            store.commit('meetingNote/UPDATE_MEETING_NOTE_SUMMARY_STATE', e.data)
        },
        failed_meeting_note_summary: function (e) {
            store.commit('meetingNote/UPDATE_MEETING_NOTE_SUMMARY_STATE', e.data)
        },
        publish_stt_result: function (e) {
            const {data: {final, text}, userId} = e;
            if(!final) return;

            const data = {
                ...e.data,
                userId: e.userId,
                date: e.eventTime,
            }
            
            store.commit('meetingNote/ADD_STT_TO_MEETING_NOTE', data)
        },
    });
  }
}
